import ConfigService from "./ConfigService";
import HttpService from "./HttpService";




export default class AddressService 
{
  constructor(coreDomain) 
  {
    this.configService = new ConfigService();
    this.domain = coreDomain || this.configService.getAddressServiceHost();

  }

  async fetchVersion(token) 
  {
    const path = "/api/admin/version";
    var response = await HttpService.get(this.domain, path, token);
    return response;
  }





async fetchAddressData(lat, lng, gcid, token) 
{
    const path = "/api/geolocation/gcid/" + gcid + "/address/lat/" + lat + "/lng/" + lng;
    var response = HttpService.get(this.domain, path, token);
    return response;

  }

}